<template>
  <transition name="fade">
    <div
      class="modal"
      :class="value ? 'show' : 'hide'"
      :style="
        value ? 'display:block;background-color:#3333337a;' : 'display:none;'
      "
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-scrollable modal-xl"
        role="document"
      >
        <div class="modal-content">
          <div class="close" @click="closeModal">
            <icon class="" width="20px" height="20px" name="times"></icon>
          </div>
          <div id="carousel" class="carousel slide h-100" data-ride="carousel">
            <div class="carousel-inner h-100">
              <div
                class="carousel-item h-100"
                :class="index === indexImage ? ' active' : ''"
                v-for="(image, index) in images"
                :key="index"
              >
                <div
                  class="image"
                  :style="
                    `background-image:url(${$config.server_url}/api/1.0/images/${image.fi_id}/1000/600/contain)`
                  "
                ></div>
              </div>
            </div>
            <a
              class="carousel-control-prev arrow"
              href="#carousel"
              role="button"
              data-slide="prev"
            >
              <span class="carousel-control-prev-icon icon" aria-hidden="true">
                <icon class="chevron" name="chevron-left"></icon>
              </span>
              <span class="sr-only">Previous</span>
            </a>
            <a
              class="carousel-control-next arrow"
              href="#carousel"
              role="button"
              data-slide="next"
            >
              <span class="carousel-control-next-icon icon" aria-hidden="true">
                <icon class="chevron" name="chevron-right"></icon>
              </span>
              <span class="sr-only">Next</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "immocarouselimages",
  components: {},
  props: {
    indexImage: Number,
    images: Array,
    value: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  async mounted() {},
  methods: {
    closeModal() {
      this.$emit("input", false);
    }
  }
};
</script>
<style scoped lang="scss">
@import "../../node_modules/bootstrap/scss/bootstrap.scss";
@import "../scss/styles.scss";
.modal-content {
  height: 90vh;
}
.arrow {
  height: 40px;
  width: 40px;
  top: calc(50% - 20px);
  background-color: #fff;
  border-radius: 50%;
}
.carousel-control-prev {
  box-shadow: -2px 3px 5px 1px #7d7d7d;
  left: 20px;
}
.carousel-control-next {
  box-shadow: 1px 3px 5px 1px #7d7d7d;
  right: 20px;
}
.chevron {
  color: black;
}
.carousel-item {
  background-color: #403f3f;
}
.image {
  background-size: contain;
  background-repeat: no-repeat;
  height: 100%;
  background-position: center;
}
.close {
  position: absolute;
  top: 0;
  right: 10px;
  color: #fff;
  z-index: 100;
  cursor: pointer;
}
</style>
